import React from 'react';
import { useSelector } from 'react-redux';
import { MEDIA_TYPE } from '../../../base/media/constants';
import { getTrackByMediaTypeAndParticipant } from '../../../base/tracks/functions.web';
import { getLargeVideoParticipant } from '../../../large-video/functions';
import { getDeepaiTheme } from '../../functions';
import VoiceWaveOverlay from './VoiceWaveOverlay';
/**
 * Scoped root class positioned by the theme CSS as a horizontal strip directly
 * below the AI (large video) tile.
 */
const ROOT_CLASS = 'deepai-ai-wave';
/**
 * The AI voice-waveform stage: a dedicated container placed *below* the large
 * video (not overlaid on it), shown only when a DeepAI theme is active, the
 * waveform is enabled in config, and the participant on the large video is the
 * AI. The user's own waveform is unaffected (handled by the thumbnail).
 *
 * @returns {JSX.Element | null}
 */
export default function DeepaiAiWaveStage() {
    const theme = useSelector(getDeepaiTheme);
    const variant = useSelector((state) => state['features/base/config'].deepaiVoiceWave);
    const largeVideoParticipant = useSelector(getLargeVideoParticipant);
    const audioTrack = useSelector((state) => (largeVideoParticipant?.id
        ? getTrackByMediaTypeAndParticipant(state['features/base/tracks'], MEDIA_TYPE.AUDIO, largeVideoParticipant.id)
        : undefined));
    if (!theme || !variant || variant === 'off' || largeVideoParticipant?.deepaiRole !== 'ai') {
        return null;
    }
    return (React.createElement("div", { className: ROOT_CLASS },
        React.createElement("span", { className: 'dai-wave-box' },
            React.createElement(VoiceWaveOverlay, { audioTrack: audioTrack, role: 'ai', variant: variant })),
        React.createElement("span", { className: 'dai-wave-ai' }, "AI")));
}
